import React from 'react';
import './MaintenancePage.css';

export default function MaintenancePage() {
  return (
    <div className="maint-root">
      {/* Decorative blobs */}
      <div className="maint-blob maint-blob-1" />
      <div className="maint-blob maint-blob-2" />

      <div className="maint-card">
        <div className="maint-logo">
          <img src="/logo-white.png" alt="Zénde" />
        </div>

        <div className="maint-badge">Coming soon</div>

        <h1 className="maint-title">
          Something exciting<br />
          <em>is on the way.</em>
        </h1>

        <p className="maint-body">
          We're putting the finishing touches on a brand new experience — curated
          places, events, and activities across Nigeria's most vibrant cities.
          We'll be live very shortly.
        </p>

        <div className="maint-divider" />

        <div className="maint-features">
          <div className="maint-feat">
            <span className="maint-feat-icon">📍</span>
            <span>Discover the best spots in your city</span>
          </div>
          <div className="maint-feat">
            <span className="maint-feat-icon">🎉</span>
            <span>Stay on top of events every week</span>
          </div>
          <div className="maint-feat">
            <span className="maint-feat-icon">🏃</span>
            <span>Plan & share activites</span>
          </div>
        </div>

        <p className="maint-footer">
          &copy; {new Date().getFullYear()} Zénde &mdash; Your City, Unlocked.
        </p>
      </div>
    </div>
  );
}
